






































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import { AxStorage } from '@/storage';

type AxIcons = { [name: string]: string };

@Component
export default class extends Mixins(AxPage) {
  @Ref()
  id!: Vue;

  @Ref()
  pass!: Vue;

  id$input!: HTMLInputElement;
  pass$input!: HTMLInputElement;

  state = {
    id: '',
    pass: '',
    check: false,
    first: false
  };

  async created() {
    await this.$nextTick();

    this.id$input = this.id.$refs.input as HTMLInputElement;
    this.pass$input = this.pass.$refs.input as HTMLInputElement;

    console.log('input');
    this.id$input.addEventListener('keypress', e => {
      if ((e.which || e.keyCode) === 13 && this.state.id.length > 0) {
        this.pass$input.focus();
      }
    });

    this.pass$input.addEventListener('keypress', e => {
      if (
        (e.which || e.keyCode) === 13 &&
        this.state.pass.length > 0 &&
        this.state.first === true
      ) {
        this.onLoginClicked();
      }
    });
    this.state.first = true;
    this.id$input.focus();
    await this.initProd();
  }

  onClicked() {
    console.log('state');
    if (this.state.check) {
      this.state.check = false;
    } else {
      this.state.check = true;
    }
    console.log('state');
    console.log(this.state);
  }

  async initProd() {
    const b = AxStorage.saveCheckUser || false;
    this.state.check = b;
    this.state.id = AxStorage.saveUser;
  }

  async initSave() {
    console.log('console');
    console.log(this.state);
    if (this.state.check) {
      AxStorage.saveCheckUser = this.state.check;
      AxStorage.saveUser = this.state.id;
    }
  }

  async onLoginClicked() {
    if (!this.state.id) {
      this.id$input.focus();
      return;
    }

    if (!this.state.pass) {
      this.pass$input.focus();
      return;
    }

    if (!this.state.first) {
      return;
    }

    await this.login(this.state.id, this.state.pass);
  }

  async login(id: string, password: string) {
    await this.$nextTick();

    this.id$input.blur();

    this.setLoading(true);
    const result = await this.API.call.login({ id, password });
    this.setLoading(false);

    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if (result.data.token) {
        this.userLogin(result);
        this.initSave();
      }
    }
  }
}
